module.exports = __webpack_public_path__ + "media/logos/logo_footer@3x-09d6c988.svg";